import { Transition } from "@headlessui/react";
import { panelClasses } from "../utils/constants";
/* ─── Shared input-toolbar helpers ─── */
/* Icon + label trigger used in the chat input toolbar. */
export const ToolbarTriggerButton = ({
  icon: Icon,
  label,
  onClick,
  active = false,
  title,
}) => (
  <button
    type="button"
    onClick={onClick}
    title={title}
    aria-expanded={active || undefined}
    className={[
      "inline-flex items-center gap-1.5 py-1 rounded-md px-1",
      "text-[13px] font-normal tracking-wide transition-colors cursor-pointer",
      "outline-none focus-visible:ring-2 focus-visible:ring-inputFocus/60",
      active ? "text-mainText" : "text-mutedText hover:text-mainText",
    ].join(" ")}
  >
    {Icon && <Icon className="h-3.5 w-3.5" strokeWidth={2} />}
    <span>{label}</span>
  </button>
);
/* Compact drop-up panel. Anchors to the nearest position: relative
   ancestor, so each dropdown's wrapper around <ToolbarTriggerButton /> +
   <DropdownPanel /> must be `relative`. Floats 16px above trigger,
   capped at 400px tall, internal scroll.                                 */
export const DropdownPanel = ({
  isOpen,
  children,
  width = "w-80",
  align = "left",
  maxHeightClass = "max-h-[400px]",
}) => {
  const alignClass = align === "right" ? "right-0" : "left-0";
  return (
    <Transition
      show={isOpen}
      enter="transition duration-150 ease-out"
      enterFrom="opacity-0 translate-y-2"
      enterTo="opacity-100 translate-y-0"
      leave="transition duration-100 ease-in"
      leaveFrom="opacity-100 translate-y-0"
      leaveTo="opacity-0 translate-y-1"
    >
      <div
        className={[
          "absolute z-[70]",
          "bottom-[calc(100%+1rem)]",
          alignClass,
          width,
        ].join(" ")}
      >
        <div
          className={[
            panelClasses,
            maxHeightClass,
            "overflow-y-auto overscroll-contain",
          ].join(" ")}
        >
          {children}
        </div>
      </div>
    </Transition>
  );
};
/* "No saved X yet." row */
export const DropdownEmptyState = ({ children }) => (
  <div className="px-3 py-6 text-[13px] font-normal tracking-wide text-mutedText">
    {children}
  </div>
);
/* Exported as a string so it can apply to both <button> and <span>
   (PromptLoader wraps inner actions in spans). */
export const smallIconBtnClasses = [
  "inline-flex items-center justify-center rounded-md p-1.5",
  "text-mutedText hover:text-mainText hover:bg-btnHover transition-colors cursor-pointer",
  "outline-none focus-visible:ring-2 focus-visible:ring-inputFocus/60",
].join(" ");
export const dropdownRowClasses = [
  "group flex w-full items-center justify-between",
  "rounded-lg px-3 py-2 text-left transition-colors cursor-pointer",
  "hover:bg-btnHover",
].join(" ");
